(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product_buttons"] && !Shopify.designMode) return;
  try {
    class ErbBuy extends HTMLElement {
    connectedCallback() {
      this.querySelector('[data-erb-minus]')?.addEventListener('click', () => {
        this.#setQuantity(-1);
      });
      this.querySelector('[data-erb-plus]')?.addEventListener('click', () => {
        this.#setQuantity(1);
      });
      this.querySelector('[data-erb-now]')?.addEventListener('click', () => {
        this.#checkout();
      });
    }

    #setQuantity(step) {
      const input = this.querySelector('.erb-buy__count');
      if (!input) return;
      const next = Math.max(1, Number(input.value || 1) + step);
      input.value = String(next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    async #checkout() {
      const add = this.querySelector('.erb-buy__add');
      if (add?.disabled) return;
      const form = this.closest('form');
      const button = this.querySelector('[data-erb-now]');
      if (!form || !button) return;
      button.disabled = true;
      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!response.ok) return;
        window.location.href = this.dataset.checkout || '/checkout';
      } catch (err) {
        console.error('Error in Buy Now checkout:', err);
      } finally {
        button.disabled = false;
      }
    }
  }

  if (!customElements.get('erb-buy')) {
    customElements.define('erb-buy', ErbBuy);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product_offer_bar"] && !Shopify.designMode) return;
  try {
    class ErbOfferBar extends HTMLElement {
    connectedCallback() {
      this.querySelector('[data-erb-copy]')?.addEventListener('click', (event) => {
        this.#copy(event.currentTarget);
      });
    }

    async #copy(button) {
      const code = button.dataset.code;
      if (!code || button.dataset.busy === 'true') return;
      button.dataset.busy = 'true';
      const copied = await this.#write(code);
      if (!copied) {
        button.dataset.busy = 'false';
        return;
      }
      const label = button.querySelector('[data-erb-copy-label]');
      const status = this.querySelector('[data-erb-status]');
      if (label) label.textContent = button.dataset.copied;
      button.setAttribute('aria-label', button.dataset.copied);
      if (status) status.textContent = button.dataset.copied;
      window.setTimeout(() => {
        if (label) label.textContent = button.dataset.label;
        button.setAttribute('aria-label', `${button.dataset.label} ${code}`);
        if (status) status.textContent = '';
        button.dataset.busy = 'false';
      }, 1600);
    }

    async #write(code) {
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(code);
          return true;
        }
      } catch (error) {
        return this.#fallback(code);
      }
      return this.#fallback(code);
    }

    #fallback(code) {
      const field = document.createElement('textarea');
      field.value = code;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.top = '-9999px';
      document.body.appendChild(field);
      field.select();
      let copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (error) {
        copied = false;
      }
      field.remove();
      return copied;
    }
  }

  if (!customElements.get('erb-offer-bar')) {
    customElements.define('erb-offer-bar', ErbOfferBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product_variant_picker"] && !Shopify.designMode) return;
  try {
    class ErbPackPicker extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
        this.#sync(input);
      });
    }

    #sync(input) {
      const value = this.querySelector('.erb-pack__value');
      if (value) value.textContent = input.value;
      const cards = this.querySelectorAll('.erb-pack__card');
      for (const card of cards) {
        card.classList.toggle('is-active', card.contains(input));
      }
    }
  }

  if (!customElements.get('erb-pack-picker')) {
    customElements.define('erb-pack-picker', ErbPackPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
